
import { Component, Prop, Vue } from "vue-property-decorator";
import PModal from "@/components/look/PModal.vue";
import { BModal } from "bootstrap-vue";
import Multiselect from "vue-multiselect";
import {
  IRequestHistorialsService,
  ISolCustomerCancellationReason,
  IUserDetailData,
} from "@/entities";
import VueFilters from "@/vue-filters";
import { i18n } from "@/i18n";
import { Action, Getter } from "vuex-class";
import { ISolCustomerOrderCancellationRequestBody, ISolCustomerResponse } from "@/services";
import { ValidationObserver, ValidationProvider } from "vee-validate";

@Component({
  name: "cancel-order-modal",
  mixins: [VueFilters],
  components: {
    PModal,
    ValidationObserver,
    ValidationProvider,
    Multiselect,
  },
})
export default class CancelOrderModal extends Vue {
  @Getter("getLoggedUser") getLoggedUser!: IUserDetailData;

  @Action("cancelPickupService") cancelPickupService!: (params: {
    countryCode: string;
    serviceId: string;
    body: ISolCustomerOrderCancellationRequestBody;
  }) => Promise<ISolCustomerResponse | undefined>;
  @Action("cancelDeliveryService") cancelDeliveryService!: (params: {
    countryCode: string;
    serviceId: string;
    body: ISolCustomerOrderCancellationRequestBody;
  }) => Promise<ISolCustomerResponse | undefined>;
  @Action("cancelDeliveryExchangeService") cancelDeliveryExchangeService!: (params: {
    countryCode: string;
    serviceId: string;
    body: ISolCustomerOrderCancellationRequestBody;
  }) => Promise<ISolCustomerResponse | undefined>;
  @Action("cancelSupplyMaterialService") cancelSupplyMaterialService!: (params: {
    countryCode: string;
    serviceId: string;
    body: ISolCustomerOrderCancellationRequestBody;
  }) => Promise<ISolCustomerResponse | undefined>;
  @Action("cancelAssistanceService") cancelAssistanceService!: (params: {
    countryCode: string;
    serviceId: string;
    body: ISolCustomerOrderCancellationRequestBody;
  }) => Promise<ISolCustomerResponse | undefined>;

  @Prop({ required: true })
  cancellationReasons!: ISolCustomerCancellationReason[];

  service: IRequestHistorialsService | undefined | null = null;
  serviceTypeDesc: string | undefined = "";
  observations = "";
  cancellationReason: ISolCustomerCancellationReason | undefined;

  constructor() {
    super();
  }

  async mounted(): Promise<void> {
    this.$on("showCancelOrderModal", (data: IRequestHistorialsService) => {
      this.showModal(data);
    });
  }

  async beforeDestroy(): Promise<void> {
    this.$off("showCancelOrderModal");
  }

  async showModal(data: IRequestHistorialsService): Promise<void> {
    this.service = data;
    this.cancellationReason = undefined;
    this.observations = "";

    switch (this.service.serviceType) {
      case 0:
        this.serviceTypeDesc = i18n.t("label.pickup").toString();
        break;
      case 1:
        if (this.service.isChange) {
          this.serviceTypeDesc = i18n.t("label.deliveryExchange").toString();
        } else {
          this.serviceTypeDesc = i18n.t("label.delivery").toString();
        }
        break;
      case 3:
        this.serviceTypeDesc = i18n.t("label.technicalAssistance").toString();
        break;
      case 4:
        this.serviceTypeDesc = i18n.t("label.supplyMaterialService").toString();
        break;
    }

    const pModal = this.$refs.cancelOrderModal as PModal;
    const bModal = pModal.$children[0] as BModal;
    bModal.show();
  }

  hideModal(): void {
    const pModal = this.$refs.cancelOrderModal as PModal;
    const bModal = pModal.$children[0] as BModal;
    bModal.hide();
  }

  makeToast(variant: string, message: string): void {
    this.$bvToast.toast(message, {
      autoHideDelay: 4000,
      variant,
      toaster: "b-toaster-bottom-center",
      noCloseButton: true,
    });
  }

  async onSubmit(): Promise<void> {
    const params = {
      countryCode: this.getLoggedUser.country!.code!,
      serviceId: this.service!.serviceId!,
      body: {
        cancellationReasonId: this.cancellationReason!.code!,
        observations: this.observations,
      } as ISolCustomerOrderCancellationRequestBody,
    };

    let res: ISolCustomerResponse | undefined;

    switch (this.service?.serviceType) {
      case 0:
        res = await this.cancelPickupService(params);
        break;
      case 1:
        if (this.service.isChange) {
          res = await this.cancelDeliveryExchangeService(params);
        } else {
          res = await this.cancelDeliveryService(params);
        }
        break;
      case 3:
        res = await this.cancelAssistanceService(params);
        break;
      case 4:
        res = await this.cancelSupplyMaterialService(params);
        break;
    }

    if (res && res.success) {
      this.makeToast("success", i18n.t("messages.cancelOrder.ok").toString());
      this.$emit("success");
      this.hideModal();
    } else {
      this.makeToast("warning", i18n.t("messages.cancelOrder.ko").toString());
    }
  }
}
